import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import moment from 'moment';
import FridgesModal from './FridgesModal';

export const VOUCHER_STATUS = {
  REDEEMABLE: 1,
  COMING_SOON: 2,
  REDEEMED: 3,
  EXPIRED: 4,
  REVOKED: 5,
};

const VOUCHER_STATUS_STRING_MAP = {
  [VOUCHER_STATUS.COMING_SOON]: '即將上架',
  [VOUCHER_STATUS.EXPIRED]: '已過期',
  [VOUCHER_STATUS.REDEEMABLE]: '可套用取貨碼',
  [VOUCHER_STATUS.REDEEMED]: '取貨完成',
  [VOUCHER_STATUS.REVOKED]: '已撤銷',
};

const VOUCHER_STATUS_COLOR_MAP = {
  [VOUCHER_STATUS.COMING_SOON]: '#000000',
  [VOUCHER_STATUS.EXPIRED]: '#aeaeae',
  [VOUCHER_STATUS.REDEEMABLE]: '#9000ff',
  [VOUCHER_STATUS.REDEEMED]: '#aeaeae',
  [VOUCHER_STATUS.REVOKED]: '#aeaeae',
};

const useStyle = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    boxShadow: '0px 0px 5px 0px rgba(157,157,157,0.5)',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1.5, 2),

  },
  header: {
    display: 'flex',
    fontSize: 16,
    justifyContent: 'space-between',
  },
  providerName: {
    fontWeight: 'bold',
  },
  body: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: theme.spacing(0.5),
  },
  footer: {
    color: '#6b6b6b',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 12,
    marginTop: theme.spacing(0.5),
  },
  redeemTime: {
    display: 'flex',
  },
  disabled: {
    opacity: 0.5,
  },
  labelContainer: {
    flexShrink: 0,
  },
  checkFridgesButton: {
    background: 'transparent',
    border: 0,
    cursor: 'pointer',
    outline: 'none',
    padding: 0,
    textDecoration: 'underline',
  },
}));

const useStatuLabelStyle = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    color: '#FFFFFF',
    fontSize: 13,
    padding: theme.spacing(0.5, 1),
  },
}));

const StatusLabel = ({ status }) => {
  const classes = useStatuLabelStyle();
  return (
    <div
      className={classes.root}
      style={{
        background: VOUCHER_STATUS_COLOR_MAP[status],
      }}
    >
      {VOUCHER_STATUS_STRING_MAP[status] || ''}
    </div>
  );
};

export default ({ data }) => {
  const [isShowFridgesModal, setIsShowFridgesModal] = useState(false);
  const [fridgeNamesToShow, setFridgeNamesToShow] = useState([]);
  const classes = useStyle();
  const {
    expirationTime,
    redeemStartTime,
    status,
    providerNames,
    productNames,
    fridgeNames,
  } = data || {};
  const rootClasses = [classes.root];
  const redeemStartTimeString = moment(redeemStartTime).utcOffset(8).format('YYYY/MM/DD (dd) HH:mm');
  const expirationTimeString = moment(expirationTime).utcOffset(8).format('YYYY/MM/DD (dd)  HH:mm');

  if (
    status === VOUCHER_STATUS.REDEEMED
    || status === VOUCHER_STATUS.EXPIRED
    || status === VOUCHER_STATUS.REVOKED
  ) {
    rootClasses.push(classes.disabled);
  }

  return (
    <div className={rootClasses.join(' ')}>
      <FridgesModal
        isOpend={isShowFridgesModal}
        names={fridgeNamesToShow}
        onClose={() => {
          setIsShowFridgesModal(false);
        }}
      />
      <div className={classes.header}>
        <div className={classes.providerName}>{`【${providerNames[0] || ''}】`}</div>
        {status
        && (
        <div className={classes.labelContainer}>
          <StatusLabel status={status} />
        </div>
        )}
      </div>
      <div className={classes.body}>
        <div>{`${productNames.join('、')}${productNames.length > 1 ? '任一商品' : ''}`}</div>
      </div>
      <div className={classes.footer}>
        <div>數量：1</div>
        <div className={classes.redeemTime}>
          <div>指定取貨機台：</div>
          {fridgeNames.length > 1
            ? (
              <button
                type="button"
                className={classes.checkFridgesButton}
                onClick={() => {
                  setIsShowFridgesModal(true);
                  setFridgeNamesToShow(fridgeNames);
                }}
              >
                可取貨機台列表
              </button>
            )
            : (fridgeNames || [])[0] || ''}
        </div>
        <div className={classes.redeemTime}>
          <div style={{ flexShrink: 0 }}>預計領取時段：</div>
          <div>{`${redeemStartTimeString} ~ ${expirationTimeString}`}</div>
        </div>
      </div>
    </div>
  );
};
